import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/zzz/logo-black.png")